'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _setImmediate2 = require('babel-runtime/core-js/set-immediate');

var _setImmediate3 = _interopRequireDefault(_setImmediate2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Loader = require('./Loader');

var _Loader2 = _interopRequireDefault(_Loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlockUi = function (_Component) {
  (0, _inherits3.default)(BlockUi, _Component);

  function BlockUi() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, BlockUi);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.tabbedUpTop = function (e) {
      if (_this.blockingTab(e)) {
        _this.blocker.focus();
      }
    }, _this.tabbedDownTop = function (e) {
      if (_this.blockingTab(e)) {
        e.preventDefault();
        _this.blocker.focus();
      }
    }, _this.tabbedUpBottom = function (e) {
      if (_this.blockingTab(e, true)) {
        _this.topFocus.focus();
      }
    }, _this.tabbedDownBottom = function (e) {
      if (_this.blockingTab(e, true)) {
        e.preventDefault();
        _this.topFocus.focus();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  BlockUi.prototype.blockingTab = function blockingTab(e) {
    var withShift = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return this.props.blocking && (e.key === 'Tab' || e.keyCode === 9) && e.shiftKey == withShift;
  };

  BlockUi.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    if (nextProps.blocking !== this.props.blocking) {
      if (nextProps.blocking) {
        // blocking started
        if (this.helper && this.helper.parentNode && this.helper.parentNode.contains && this.helper.parentNode.contains(document.activeElement)) {
          this.focused = document.activeElement;
          // https://www.tjvantoll.com/2013/08/30/bugs-with-document-activeelement-in-internet-explorer/#blurring-the-body-switches-windows-in-ie9-and-ie10
          if (this.focused && this.focused !== document.body) {
            (0, _setImmediate3.default)(function () {
              return _this2.topFocus && _this2.topFocus.focus();
            });
          }
        }
      } else {
        var ae = document.activeElement;
        if (this.focused && (!ae || ae === document.body || ae === this.topFocus)) {
          this.focused.focus();
          this.focused = null;
        }
      }
    }
  };

  BlockUi.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        Tag = _props.tag,
        blocking = _props.blocking,
        className = _props.className,
        children = _props.children,
        Loader = _props.loader,
        renderChildren = _props.renderChildren,
        attributes = (0, _objectWithoutProperties3.default)(_props, ['tag', 'blocking', 'className', 'children', 'loader', 'renderChildren']);


    var classes = blocking ? (0, _classnames2.default)('av-block-ui', className) : className;
    var renderChilds = !blocking || renderChildren;

    return _react2.default.createElement(
      Tag,
      (0, _extends3.default)({}, attributes, { className: classes, 'aria-busy': blocking }),
      blocking && _react2.default.createElement('div', { tabIndex: '0', onKeyUp: this.tabbedUpTop, onKeyDown: this.tabbedDownTop, ref: function ref(c) {
          return _this3.topFocus = c;
        } }),
      renderChilds && children,
      blocking && _react2.default.createElement(
        'div',
        { className: 'av-block-ui-container',
          tabIndex: '0',
          ref: function ref(c) {
            return _this3.blocker = c;
          },
          onKeyUp: this.tabbedUpBottom,
          onKeyDown: this.tabbedDownBottom },
        _react2.default.createElement('div', { className: 'av-block-ui-overlay' }),
        _react2.default.createElement(
          'div',
          { className: 'av-block-ui-message-container' },
          _react2.default.createElement(
            'div',
            { className: 'av-block-ui-message' },
            _react2.default.isValidElement(Loader) ? Loader : _react2.default.createElement(Loader, null)
          )
        )
      ),
      _react2.default.createElement('span', { ref: function ref(c) {
          return _this3.helper = c;
        } })
    );
  };

  return BlockUi;
}(_react.Component);

BlockUi.propTypes = {
  blocking: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  renderChildren: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  loader: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.node]),
  tag: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
};
BlockUi.defaultProps = {
  tag: 'div',
  renderChildren: true,
  loader: _Loader2.default
};
exports.default = BlockUi;


//////////////////
// WEBPACK FOOTER
// ./~/react-block-ui/lib/BlockUi.js
// module id = 884
// module chunks = 0